import { createContext, useContext } from 'react';
import type { MarkResult } from '$/components/InlineBox/types';
import type { InlineBoxClickHandler, RenderMarkPopover } from './types';

export interface InputTextAreaContextValue {
  renderMarkPopover?: RenderMarkPopover;
  /** 点击输入框内 inlineBox 时通知宿主，参数与 MediaInput 预览项一致。 */
  onInlineBoxClick?: InlineBoxClickHandler;
  /** 获取指定节点的 Mark 识别结果列表（由 fetchMarkResults 异步填充或 resultList 同步传入） */
  getMarkResults?: (nodeKey: string) => MarkResult[] | undefined;
}

export const InputTextAreaContext = createContext<InputTextAreaContextValue>({});

export const useInputTextAreaContext = () => useContext(InputTextAreaContext);
